import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Data/BillTos/Handlers/UpdateBillTo";
import { updateBillTo as updateBillToApi } from "@store/Services/CustomersService"; // Poolcorp Custom Code

replaceInChain(chain, SendDataToApi, async props => {
    if (props.apiParameter.isEdit) {
        props.apiResult = await updateBillToApi(props.apiParameter); // Poolcorp Custom Import
    } else {
        props.apiResult = props.apiParameter.billTo;
    }
});
